import "antd/dist/antd.css";
import axios from "axios";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import Select from "react-select";
import swal from "sweetalert";
import useSWR from "swr";
import Api from "../../../../../initialpage/hooks/Api";
import { API } from "../../../StoreComponents/conflict";
const fetcher = (url) => API.get(url).then((res) => res.data.data);

const ProjectAssetEntry = () => {
  // console.log(logInStatus)
  const [search, setSearch] = useState("");
  const [singleData, setSingleData] = useState();
  const [arrayData, setArrayData] = useState([]);
  const [openElement, setOpenElement] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [projectSubject, setProjectSubject] = useState("");
  const [projectproductSupDate, setProjectproductSupDate] = useState("");
  const [selectedProduct, setSelectedProduct] = useState({});
  // console.log(error);
  // react hook form
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = (data) => {
    console.log(photoPath, projectName, projectproductSupDate);
    const product = {
      PRODUCT_QTY: parseFloat(data.PRODUCT_QTY),
      PRODUCT_NAME: selectedProduct.label,
      PRODUCT_CODE: selectedProduct.value,
      REMARKS: data.REMARKS,
    };
    //   console.log(product);
    setArrayData([...arrayData, product]);
    setSelectedProduct({});
    reset();
  };
  const deleteProduct = (id) => {
    console.log(id);
    const proceed = window.confirm("Are you sure?");
    if (proceed) {
      const remaining = arrayData.filter((product, index) => index !== id);
      setArrayData(remaining);
    }
  };
  const handleRequest = () => {
    swal({
      title: "Are you sure?",
      //  text: "Once deleted, you will not be able to recover this imaginary file!",
      buttons: true,
      //  dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setButtonLoading(true);
        if (arrayData.length > 0) {
          API.post("store/products/project/asset/entry", {
            FilePath: photoPath,
            ProjectName: projectName,
            ProjectSubject: projectSubject,
            ProjectDate: `${projectproductSupDate}T00:00:00Z`,
            products: arrayData,
          }).then((res) => {
            console.log(res);
            if (!res.data.error) {
              swal({
                title: "Thank You !",
                text: "Successfully Added",
                icon: "success",
                button: "Ok",
              });

              setButtonLoading(false);
              setArrayData([]);
              setOpenElement(false);
            }
          });
        } else {
          alert("Sorry, You dont have any data!");
        }
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };
  const [photoPath, setPhotoPath] = useState("");
  //  image post path get
  const storeImageHandle = (e) => {
    const imageStore = e.target.files[0];
    //
    const formData = new FormData();
    formData.append("image", imageStore);
    axios({
      method: "post",
      url: `https://${Api}/mrrFile`,
      data: formData,
      headers: { Authorization: "Bearer ..." },
    }).then((data) => {
      console.log(data.data);
      setPhotoPath(data.data);
    });
  };
  const { data: productOption, error: error1 } = useSWR(
    `store/settings/productByCatId/22?limit=${10000}`,
    fetcher
  );

  // set Product select list
  let productCategory = [];
  if (productOption && productOption.length > 0) {
    productCategory = productOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.PRODID;
      optionsItem.label = `${data.PRONAME} - ${data.PRONAMETWO}`;
      return optionsItem;
    });
  }
  // handle product select;
  const handleProduct = (product) => {
    setSelectedProduct(product);
  };

  console.log(arrayData);
  return (
    <>
      <Helmet>
        <title>Project Asset Product - BBA STORE</title>
        <meta name="description" content="Request Product - BBA STORE" />
      </Helmet>

      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important} "
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4 search-div_store">
            <h3 className="text-start text-dark">
              Project Asset Product Entry
            </h3>
          </div>

          <div className="mx-auto text-center">
            <div className="add_category">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="container px-4">
                  <div className="row gx-5">
                    <div className="col-sm-6">
                      {" "}
                      <div className="col-sm-12">
                        <label htmlFor="Quantity">
                          Project Name <span className="color-red">*</span>
                        </label>
                        <div className="pass-wrapper d-flex input-group mb-3">
                          <input
                            type="text"
                            placeholder="Enter Project Name"
                            className=" form-control "
                            defaultValue={projectName}
                            onChange={(e) => setProjectName(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <label htmlFor="Quantity">
                          Project Subject <span className="color-red">*</span>
                        </label>
                        <div className="pass-wrapper d-flex input-group mb-3">
                          <input
                            type="text"
                            placeholder="Enter Project Subject"
                            className=" form-control "
                            defaultValue={projectSubject}
                            onChange={(e) => setProjectSubject(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <label htmlFor="Quantity">
                          Project Product Supply Date{" "}
                          <span className="color-red">*</span>
                        </label>
                        <div className="pass-wrapper d-flex input-group mb-3">
                          <input
                            type="date"
                            className=" form-control "
                            defaultValue={projectproductSupDate}
                            onChange={(e) =>
                              setProjectproductSupDate(e.target.value)
                            }
                            required
                          />
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <label htmlFor="Quantity">
                          Document <span className="color-red">*</span>
                        </label>
                        <div className="pass-wrapper d-flex input-group mb-3">
                          <input
                            className="form-control"
                            type="file"
                            onChange={(e) => storeImageHandle(e)}
                            id="formFile"
                          />
                        </div>
                      </div>
                      <div className="col-sm-12  col-md-12 col-lg-12">
                        <label htmlFor="Quantity">
                          Product Name <span className="color-red">*</span>
                        </label>
                        <div className="pass-wrapper d-flex input-group mb-3 ">
                          <Select
                            onChange={handleProduct}
                            style={{ borderRadius: "10px" }}
                            className="text-start fs-6 w-100"
                            options={productCategory}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <label htmlFor="Quantity">
                          Quantity <span className="color-red">*</span>
                        </label>
                        <div className="pass-wrapper d-flex input-group mb-3">
                          <input
                            {...register("PRODUCT_QTY")}
                            type="number"
                            min="1"
                            step={0.01}
                            placeholder="Enter Quantity"
                            className=" form-control "
                            required
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <label htmlFor="remarks">Remarks/Location</label>
                        <textarea
                          {...register("REMARKS")}
                          placeholder="Enter Remarks"
                          className="input-field-new p-2"
                          cols="20"
                          rows="2"
                        ></textarea>
                      </div>
                      <button
                        type="submit"
                        className="mt-3 px-3 btn btn-color_store"
                      >
                        <i className="fa fa-add"></i>
                        <span> Add</span>
                      </button>
                    </div>
                    <div className="col-sm-6">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr
                            style={{
                              backgroundColor: "#3C8DBC",
                              color: "white",
                              textAlign: "center",
                            }}
                          >
                            <th>S/N</th>
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Remarks</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {arrayData?.map((item, index) => (
                            <tr>
                              <td>{++index}</td>
                              <td className="text-start">
                                {item.PRODUCT_NAME}
                              </td>
                              <td>{item.PRODUCT_QTY}</td>
                              <td className="text-start">{item.REMARKS}</td>
                              <td>
                                {" "}
                                <button
                                  onClick={() => deleteProduct(--index)}
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                  type="button"
                                  className="btn btn-red_store px-3"
                                >
                                  <i className="fa fa-times fs-6"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <br />
                {!buttonLoading ? (
                  <button
                    onClick={handleRequest}
                    className="btn btn-color_store px-3 mt-3"
                  >
                    {" "}
                    <i className="fa fa-send-o" /> <span>Save</span>
                  </button>
                ) : (
                  <button className="btn btn-color_store px-3 mt-3">
                    {" "}
                    <i className="fa fa-send-o" /> <span>Save</span>
                    <div
                      style={{ width: "20px", height: "20px" }}
                      class="spinner-border ms-2  text-light"
                      role="status"
                    >
                      <span style={{}} class="visually-hidden ">
                        Loading...
                      </span>
                    </div>
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectAssetEntry;
